export type UserType = {

    name: string,
    email: string,
    roles: string[],
    numPC: string,
    isAuthorized: boolean,
    isAuthenticated: boolean
};

export const UserEmptyState: UserType = {
    name: '',
    email: '',
    roles: [],
    numPC: '',
    isAuthorized: false,
    isAuthenticated: false
}